module.exports = __webpack_public_path__ + "static/media/office-photo.6b19d456.svg";